import Vue from 'vue'
import 'bootstrap-table/dist/bootstrap-table.min.css'
import 'bootstrap-table/dist/bootstrap-table.js'
import BootstrapTable from 'bootstrap-table/dist/bootstrap-table-vue.esm.js'
import 'bootstrap-table/dist/extensions/export/bootstrap-table-export'
import 'tableexport.jquery.plugin/libs/FileSaver/FileSaver.min';
import 'tableexport.jquery.plugin/libs/js-xlsx/xlsx.core.min';
import 'tableexport.jquery.plugin';


Vue.component('BootstrapTable', BootstrapTable);
(<any>jQuery.fn).bootstrapTable.defaults.icons = {
    detailOpen: 'dripicons-chevron-right',
    detailClose: 'dripicons-chevron-down',
    columns: 'fas fa-th-list',
    export: 'fa-download'
};
